import styled from 'styled-components';
import { Alert } from 'react-bootstrap';

export const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 1rem;
`;
